import Box from "@mui/material/Box";

import AddToPortfolio from "@components/Forms/AddToPortfolio";
import ResourceLink from "@components/ResourceLink";

import C from "@constants/constants";

import { CompanyType } from "@interfaces/company.type";
import { IFetchCompanySearch } from "@interfaces/ipsearch.type";

import SmartSearchForm from "@pages/Companies/components/SmartSearchForm";

import { useAddCompaniesToTechnologyQuery, useCreateTechnologyFromCompanyIdsQuery } from "@queries/portfolio.query";

import { PopupActions } from "@store/popupStore";
import useSmartSearchStore from "@store/smartSearch";

interface ISmartSearchToolbar {
  allCompanies: CompanyType[];
  fetchCompanySearch: ({ preferredIndustries, queryString }: IFetchCompanySearch) => void;
  isFilterOpen: boolean;
  searchId: string;
  selectedIds: string[];
  setIsFilterOpen: (isOpen: boolean) => void;
}

const useEmbeddingSearchToolbar = ({
  allCompanies,
  fetchCompanySearch,
  isFilterOpen,
  searchId,
  selectedIds,
  setIsFilterOpen,
}: ISmartSearchToolbar) => {
  const { mutateAsync: createTechnologyFromId } = useCreateTechnologyFromCompanyIdsQuery();
  const { mutateAsync: addCompaniesToTechnology } = useAddCompaniesToTechnologyQuery();
  const { isSmartSearchEnabled, smartSearchDescription } = useSmartSearchStore();

  const toggleFilterVisibility = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const companiesToAddOrRemove = allCompanies
    .filter((company) => selectedIds.includes(company.id))
    .map((company) => company.id)
    .map((id) => id);

  const handleSmartSearch = () => {
    PopupActions.openModal({
      content: <SmartSearchForm fetchCompanySearch={fetchCompanySearch} />,
      title: (
        <Box sx={{ alignItems: "center", display: "flex", gap: 1 }}>
          Portfolio Search <ResourceLink resourceLink={C.LOOM_IP_SEARCH} workflow="smart-search" />
        </Box>
      ),
    });
  };

  const handleAddCompaniesToTechnology = () => {
    //?: Do we need description here?
    let description = null;
    if (smartSearchDescription) {
      description = smartSearchDescription;
    }

    PopupActions.openModal({
      content: (
        <AddToPortfolio
          addToTechnology={async (technologyId, technologyName) => {
            await addCompaniesToTechnology({
              companyIds: companiesToAddOrRemove,
              searchId,
              technologyId,
              technologyName,
            });
            PopupActions.closeModal();
          }}
          createTechnology={async (name: string, description?: string) => {
            await createTechnologyFromId({
              companyIds: companiesToAddOrRemove,
              description: isSmartSearchEnabled ? description : "",
              name,
              searchId,
            });
            PopupActions.closeModal();
          }}
        />
      ),
      title: "Save to Technology",
    });
  };

  return {
    handleAddCompaniesToTechnology,
    handleSmartSearch,
    toggleFilterVisibility,
  };
};

export default useEmbeddingSearchToolbar;
